export default __webpack_public_path__ + "static/media/padel-platinum-cover.aaa9621b.png";